module.exports = __webpack_public_path__ + "img/XaaSSliderPlaformKubernetes.aafc163.svg";